import { Filter } from 'bad-words';
const filter = new Filter();
export const nameErrorMessages = {
  "au-name-length": "Name must be 50 characters or less.",
  "au-first-name-length": "First name must be 40 characters or less.",
  "au-last-name-length": "Last name must be 50 characters or less.",
  "au-name-chars": "Name can only contain letters, apostrophes, hyphens, and spaces.",
  "au-name-only-punct": "Name cannot be only apostrophes or hyphens.",
  "au-name-edge-punct": "Name cannot start or end with a hyphen, apostrophe, or space.",
  "au-name-double-space": "Name cannot have more than one space in a row.",
  "au-name-only-space": "Apostrophes, hyphens, and spaces must be placed between letters.",
  "au-name-double-hyphen": "Apostrophes, hyphens, and spaces must be placed between letters.",
  "au-name-double-apostrophe": "Apostrophes, hyphens, and spaces must be placed between letters.",
  "au-name-at-least-one-letter": "Name must contain at least one letter.",  
  "au-name-profanity": "Name contains inappropriate language. Please remove to continue.",
  "au-name-single-special": "Apostrophe, hyphen, or space can appear only once in total.",
  "au-name-special-between-letters": "Special characters must be between letters, not next to each other or at the start/end."
};

export const customValidators = [
    {
        ID: "au-first-name-length",
        validate: (input) => input.value.length <= 40
    },
    {
        ID: "au-last-name-length",
        validate: (input) => input.value.length <= 50
    },
    {
        ID: "au-name-length",
        validate: (input) => input.value.length <= 50
    },
    {
        ID: "au-name-chars",
        validate: (input) => /^[a-zA-Z'\- ]*$/.test(input.value)
    },
    {
        ID: "au-name-only-punct",
        validate: (input) => !/^['\-]+$/.test(input.value)
    },
    {
        ID: "au-name-edge-punct",
        validate: (input) => !/^['\- ]/.test(input.value) && !/['\- ]$/.test(input.value)
    },
    {
        ID: "au-name-double-space",
        validate: (input) => !/  +/.test(input.value)
    },
    {
        ID: "au-name-single-special",
        validate: (input) => {
            const value = input.value;
            // Count all occurrences of ', -, and space
            const total = (value.match(/['\- ]/g) || []).length;
            // If any of them appears more than once in total, fail
            return total <= 1;
        }
    },
    {
        ID: "au-name-special-between-letters",
        validate: (input) => !/^['\- ]|['\- ]$/.test(input.value) || !/['\- ]{2,}/.test(input.value) || !/[^a-zA-Z]['\- ]|['\- ][^a-zA-Z]/.test(input.value)
    },
    {
        ID: "au-name-only-space",
        validate: (input) => !/^ +$/.test(input.value)
    },
    {
        ID: "au-name-double-hyphen",
        validate: (input) => !/--+/.test(input.value)
    },
    {
        ID: "au-name-double-apostrophe",
        validate: (input) => !/''+/.test(input.value)
    },
    {
        ID: "au-name-at-least-one-letter",
        validate: (input) => {
            let trimmed = input.value.replace(/^[^a-zA-Z]+/, "").replace(/[^a-zA-Z]+$/, "");
            return !!trimmed;
        }
    },

    {
        ID: "au-name-profanity",
        validate: (input) => {
            if (!input.value) return true;
            return !filter.isProfane(input.value);
        }
    },
    {
        ID: "au-date",
        validate: (input) => {
            var pattern = /^(0[1-9]|[1-2][0-9]|3[0-1])(\/)(0[1-9]|1[0-2])(\/)(\d{4})$/gi;
            return pattern.test(input.value);
        }
    },
    {
        ID: "au-postcode",
        validate: (input) => {
            var pattern = /^(\d{4})$/;
            return pattern.test(input.value);
        }
    }

];
